import { render, staticRenderFns } from "./Clima.vue?vue&type=template&id=655c6173&scoped=true&"
import script from "./Clima.vue?vue&type=script&lang=js&"
export * from "./Clima.vue?vue&type=script&lang=js&"
import style0 from "./Clima.vue?vue&type=style&index=0&id=655c6173&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655c6173",
  null
  
)

export default component.exports